// extracted by mini-css-extract-plugin
module.exports = {"contactDetailsBoxWrapper":"contact-us-product-stock-tool-solution_contactDetailsBoxWrapper__NeaaD"};